import { type Language, LanguageContext } from "@digipost/translate";
import { FC, ReactNode } from "react";
import { parseLanguage } from "./useRootPath";

type Props = {
  children: ReactNode;
};

export const LanguageProvider: FC<Props> = ({ children }) => {
  const pathLanguage = location.pathname.split("/")[1];

  const setLanguage = (newLanguage: Language) => {
    const localPathLang = location.pathname.split("/")[1];
    window.location.href = location.pathname.replace(
      localPathLang === parseLanguage(localPathLang) ? "/" + localPathLang : "",
      "/" + newLanguage,
    );
  };

  return (
    <LanguageContext.Provider
      value={{
        language: parseLanguage(pathLanguage),
        setLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
